/**
 * Get advertiser ID from URL search params.
 * @param url
 */
export function getAdvertiserId(url: URL): string | null {
  if (url.searchParams.has('advertiserId')) {
    return url.searchParams.get('advertiserId')!;
  }

  if (url.searchParams.has('maklerId')) {
    return url.searchParams.get('maklerId')!;
  }

  if (url.searchParams.has('referrerId')) {
    return url.searchParams.get('referrerId')!;
  }

  return null;
}
